/* eslint-disable no-param-reassign */
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TextField,
  Autocomplete,
  Notification,
  Grid,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from '@xbotvn/mui';
import {
  get, includes, map, replace, toLower,
} from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useState,
} from 'react';

import YouTubeStudioWarning from '../../../components/YouTubeStudioWarning';
import {
  convertGGDriveUrl,
  convertYoutubeStudioUrl,
  getCover,
  getThumbnail,
  normalizeText,
  SUBJECTS_BOOK,
} from '../../../libs/utils';

export default function Editor({
  onHandler = () => { },
  data: initData = {},
  onClose,
  unitInfo,
}) {
  const [data, setData] = useState(initData);
  const [studioUrlDialog, setStudioUrlDialog] = useState();

  return (
    <>
      <YouTubeStudioWarning
        open={!!studioUrlDialog}
        studioUrlDialog={studioUrlDialog}
        onClose={() => setStudioUrlDialog(null)}
        onConvert={(url) => {
          setData((prevData) => ({
            ...prevData,
            bookLink: url,
          }));
        }}
      />
      <Dialog maxWidth="lg" fullWidth open onClose={onClose}>
        <DialogTitle onClose={onClose}>{`${initData?._id ? 'Sửa' : 'Thêm'} sách cho trẻ`}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <img
                style={{ objectFit: 'fill' }}
                width="100%"
                height="100%"
                src={getCover(data)}
                srcSet={getCover(data)}
                alt={data?.name}
                loading="lazy"
                onError={({ currentTarget }) => {
                  const fallback = `/${data?.subject}.png`;
                  if (currentTarget.src.includes(fallback)) {
                    currentTarget.onerror = null;
                    return;
                  }
                  currentTarget.src = fallback;
                }}
              />
            </Grid>
            <Grid item xs={7}>
              <TextField
                label="Nhan đề sách"
                value={get(data, 'name', '')}
                onChange={(e) => {
                  setData((prevData) => ({
                    ...prevData,
                    name: e.target.value,
                  }));
                }}
                required
              />
              <Autocomplete
                options={map(SUBJECTS_BOOK,
                  (value, key) => ({
                    label: value,
                    value: key,
                  }))}
                value={SUBJECTS_BOOK?.[get(data, 'subject', '')]}
                onChange={(e, value) => setData((prevData) => ({
                  ...prevData,
                  subject: value?.value,
                }))}
                renderInput={(params) => <TextField {...params} label="Chủ đề" placeholder="Chọn chủ đề" />}
              />
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    label="Đường link bìa sách"
                    value={get(data, 'coverLink', '')}
                    onChange={(e) => {
                      const coverLink = getThumbnail(e.target.value);
                      setData((prevData) => ({
                        ...prevData,
                        coverLink,
                      }));
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    label="Đường link sách"
                    value={get(data, 'bookLink', '')}
                    onChange={(e) => {
                      const url = e.target.value;
                      setData((prevData) => ({
                        ...prevData,
                        bookLink: url,
                      }));
                      const studioData = convertYoutubeStudioUrl(url);
                      if (studioData) {
                        setStudioUrlDialog(studioData);
                      }
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={4} display="flex" alignItems="center">
                  <Tooltip
                    title="Khi tick công khai phụ huynh có thể xem sách tại đường link sách cho trẻ của trường mà không cần đăng nhập"
                    placement="top"
                  >
                    <div>
                      <FormControlLabel
                        control={(
                          <Checkbox
                            checked={get(data, 'isPublic', false)}
                            onChange={(e) => setData((prevData) => ({
                              ...prevData,
                              isPublic: e.target.checked,
                            }))}
                            color="primary"
                          />
                        )}
                        label="Công khai"
                      />
                    </div>
                  </Tooltip>
                </Grid>
              </Grid>
              {data.isPublic ? (
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    const normalizeStr = replace(normalizeText(toLower(unitInfo?.name || '')), / /g, '_');
                    window.open(`${window.location.origin}/sachChoTre/${normalizeStr}/${data.unitId}`, '_blank');
                  }}
                  style={{ marginTop: 10 }}
                >
                  Link công khai
                </Button>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <img
                style={{ objectFit: 'fill' }}
                width="100%"
                height="100%"
                src={data?.positionLink}
                srcSet={data?.positionLink}
                alt="position"
                loading="lazy"
              />
            </Grid>
            <Grid item xs={7}>
              <TextField
                fullWidth
                label="Đường link vị trí sách"
                value={get(data, 'positionLink', '')}
                onChange={(e) => {
                  let positionLink = e.target.value;
                  if (includes(positionLink, 'drive.google.com/file/d/')) {
                    positionLink = convertGGDriveUrl(positionLink);
                  }
                  setData((prevData) => ({
                    ...prevData,
                    positionLink,
                  }));
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            onClick={() => {
              const {
                name, subject, coverLink, bookLink,
              } = data;
              if (!name) {
                Notification.warn('Họ tên không được bỏ trống.');
                return;
              }
              if (!subject) {
                Notification.warn('Chủ đề không được bỏ trống.');
                return;
              }
              if (!coverLink) {
                Notification.warn('Đường link ảnh bìa không được bỏ trống.');
                return;
              }
              if (!bookLink) {
                Notification.warn('Đường link sách online không được bỏ trống.');
                return;
              }
              onHandler(data);
            }}
          >
            Lưu
          </Button>
          <Button color="warning" onClick={onClose}>
            Huỷ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

Editor.propTypes = {
  data: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onHandler: PropTypes.func,
  unitInfo: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};
